import { LoginFormEffect } from "./login-form.effect";
import { LoginProfileEffect } from "./login-profile.effect";
import { LoginRegisterEffect } from "./login-register.effect";
import { LanguagesEffects } from "./languages.effect";

export const effects: any[] = [
    LoginFormEffect,
    LoginProfileEffect,
    LoginRegisterEffect,
    LanguagesEffects
];

export * from "./login-form.effect";
export * from "./login-profile.effect";
export * from "./login-register.effect";
export * from "./languages.effect";
